import client from './client';

export async function listCandidates(params) {
  const { data } = await client.get('/candidates', { params });
  return data.data; // Laravel paginator
}

export async function exportCandidates(params) {
  return client.get('/candidates/export', { params, responseType: 'blob' });
}

export async function getCandidate(id) {
  const { data } = await client.get(`/candidates/${id}`);
  return data.data;
}

export async function createCandidate(payload) {
  const { data } = await client.post('/candidates', payload);
  return data.data;
}

export async function updateCandidate(id, payload) {
  const { data } = await client.put(`/candidates/${id}`, payload);
  return data.data;
}

export async function deleteCandidate(id) {
  await client.delete(`/candidates/${id}`);
}

export async function withdrawCandidate(id, reason) {
  const { data } = await client.patch(`/candidates/${id}/withdraw`, { reason });
  return data.data;
}

export async function reopenCandidate(id) {
  const { data } = await client.patch(`/candidates/${id}/reopen`);
  return data.data;
}

export async function changeCandidateCategory(id, workflow_category_id) {
  const { data } = await client.patch(`/candidates/${id}/change-category`, { workflow_category_id });
  return data.data;
}

export async function processCandidateStep(candidateId, candidateStepId, payload) {
  const { data } = await client.post(`/candidates/${candidateId}/steps/${candidateStepId}/process`, payload);
  return data.data;
}

export async function revertCandidateStep(candidateId) {
  const { data } = await client.post(`/candidates/${candidateId}/steps/revert`);
  return data.data;
}
